import React from 'react';
import Toggle from '../components/Toggle';
import T from '../components/T';

const CookiesToggle = ({ expanded, setExpanded, labelId, children, value, onValueChanged, id, disabled }) => (
  <div className="cookies-toggle">
    <div className="toggle-panel">
      <Toggle
        checked={value}
        setChecked={onValueChanged}
        id={id}
        disabled={disabled}
      />
      <b className="padded"><T msg={labelId} /></b>
      <button type="button" className="button-link" onClick={() => setExpanded(!expanded)}>
        {expanded && <T msg="cookieConsent.common.lessInfo" />}
        {!expanded && <T msg="cookieConsent.common.moreInfo" />}
      </button>
    </div>
    {expanded && children}
  </div>
);

export default CookiesToggle;



// WEBPACK FOOTER //
// ./app/Assets/js/features/cookieConsent/CookiesToggle.js